<script>
import { useEsignStore } from '../../stores/esign'
import * as api from '../../api/esignApi'
import EcComboSelect from '../ui/EcComboSelect.vue'

export default {
  name: 'TemplateSelector',
  components: {
    EcComboSelect,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    holderType: {
      type: String,
      required: true,
    },
    holderId: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fromSignable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var store = useEsignStore()
    return {
      store: store,
      loadingDetail: false,
    }
  },
  computed: {
    computedOptions() {
      return this.store.dropdownTemplates.map(function (t) {
        return { value: String(t.id), label: t.name }
      })
    },
    computedValue() {
      return String(this.value || '')
    },
    isDisabled() {
      return this.disabled || this.store.loading || this.loadingDetail
    },
  },
  async mounted() {
    var filter = {}
    if (this.fromSignable) {
      filter.from_signable = 1
    }
    await this.store.listTemplates(this.holderType, this.holderId, {
      filter: filter,
    })
  },
  methods: {
    async onSelect(value) {
      this.$emit('input', value)

      // Reload the full template with include_fields to get signers, documents, fields from OneSpan
      this.loadingDetail = true
      try {
        var filter = { include_fields: 1 }
        if (this.fromSignable) {
          filter.from_signable = 1
        }
        var result = await api.listTemplates(this.holderType, this.holderId, {
          Id: value,
          filter: filter,
        })

        // Extract the single template from the result
        var template = null
        if (Array.isArray(result)) {
          template = result.find(function (t) { return String(t.id || t.Id) === String(value) }) || result[0] || null
        } else if (result && typeof result === 'object' && result.id) {
          template = result
        } else if (result && typeof result === 'object' && Array.isArray(result.data)) {
          var arr = result.data
          template = arr.find(function (t) { return String(t.id || t.Id) === String(value) }) || arr[0] || null
        }

        if (template) {
          this.$emit('template-selected', template)
        }
      } finally {
        this.loadingDetail = false
      }
    },
  },
}
</script>

<template>
  <EcComboSelect
    :value="computedValue"
    :options="computedOptions"
    placeholder="Rechercher un modèle..."
    :disabled="isDisabled"
    @input="onSelect"
  />
</template>
